/* eslint-disable */
export default {
  flipHeader: 'Basculer l’appel vers...',
  flip: 'Basculer',
  complete: 'Terminer le basculement',
} as const;

// @key: @#@"flipHeader"@#@ @source: @#@"Flip Call to..."@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"complete"@#@ @source: @#@"Complete Flip"@#@
